var cell_default = {
  "cell": "g0qAE",
  "header": "cZME3",
  "selected": "wx2QA",
  "editing": "qgq6b",
  "singleSelection": "GdZJc",
  "hideLastBlock": "GxRVv",
  "editorWrapper": "UhE3m",
  "viewerWrapper": "aYJMk",
  "hideFirstBlock": "a5Ooi",
  "editor": "bEom7",
  "edit": "_23pko",
  "view": "_--RQx",
  "editingToolbarWrapper": "_5N8F1",
  "selectAll": "zr7nn",
  "disableSelection": "xiCI2"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
